import { DependencyList, EffectCallback, useEffect } from 'react'
import useSWR from 'swr'
import { useActiveChainId } from './useActiveChainId'

type BlockEffectCallback = (blockNumber: number) => ReturnType<EffectCallback>

const EMPTY_ARRAY = []

export function useRefreshEffect(interval: number, effect: BlockEffectCallback, deps?: DependencyList) {
  const { chainId } = useActiveChainId()
  const { data = 0 } = useSWR(chainId && [interval, 'blockNumber', chainId])

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(effect.bind(null, data), [data, ...(deps || EMPTY_ARRAY)])
}
